import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type DropdownMenuSeparatorProps = RadixDropdownMenu.DropdownMenuSeparatorProps;

export const DropdownMenuSeparator = memo(({ className, ...restOfProps }: DropdownMenuSeparatorProps) => {
  return (
    <RadixDropdownMenu.Separator
      className={cn('-mx-2 h-px shrink-0 bg-grey-4 last:hidden', className)}
      data-testid="DROPDOWN_MENU_SEPARATOR"
      {...restOfProps}
    />
  );
});

DropdownMenuSeparator.displayName = 'DropdownMenuSeparator';
